import React from 'react'
import PropTypes from 'prop-types'

const classNames = require('classnames')

const GlgProgressBar = ({
  percentage,
  containerClassName = '',
  barClassName = '',
  fillClassName = '',
}) => {
  // Clamp percentage between 0 and 100
  const clampedPercentage = Math.min(Math.max(percentage, 0), 100)

  const finalContainerClass = classNames('glg-progress-container', containerClassName)
  const finalBarClass = classNames('glg-progress-bar', barClassName)
  const finalFillClass = classNames('glg-progress-fill', fillClassName)

  return (
    <div
      className={finalContainerClass}
      role="progressbar"
      aria-valuenow={clampedPercentage}
      aria-valuemin={0}
      aria-valuemax={100}
      >
      <div
        className={finalBarClass}
      >
        <div
          className={finalFillClass}
          style={{
            width: `${clampedPercentage}%`,
          }}
        />
      </div>
    </div>
  )
}

GlgProgressBar.propTypes = {
  percentage: PropTypes.number.isRequired,
  containerClassName: PropTypes.string,
  barClassName: PropTypes.string,
  fillClassName: PropTypes.string,
}

export default GlgProgressBar
